(function(){
  'use strict';

  var modal, body, slides, viewport, variantsWrap, variantsBox, titleEl, descEl,
      compareEl, priceEl, atcBtn, detailsLink, loadingEl, prevBtn, nextBtn;
  var state = { product: null, variantIdx: 0, slideIdx: 0, busy: false };
  var cache = {};

  function money(cents){
    var n = (Number(cents) / 100).toFixed(2);
    return '₹' + n;
  }

  function qs(sel){ return modal.querySelector(sel); }

  function renderPrices(){
    var v = state.product.variants[state.variantIdx];
    var showCompare = v.compare_at_price && v.compare_at_price > v.price;
    compareEl.hidden = !showCompare;
    if (showCompare) compareEl.textContent = money(v.compare_at_price);
    priceEl.textContent = money(v.price);
  }

  function renderAtc(){
    var v = state.product.variants[state.variantIdx];
    atcBtn.disabled = !v.available;
    atcBtn.classList.toggle('is-disabled', !v.available);
    atcBtn.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
  }

  function renderVariants(){
    var p = state.product;
    if (p.variants.length < 2) {
      variantsWrap.hidden = true;
      return;
    }
    variantsWrap.hidden = false;
    variantsBox.innerHTML = '';
    p.variants.forEach(function(vr, i){
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'upsell-modal__chip';
      if (i === state.variantIdx) c.classList.add('is-active');
      if (!vr.available) c.classList.add('is-sold-out');
      c.textContent = vr.title;
      c.setAttribute('data-upsell-variant', i);
      variantsBox.appendChild(c);
    });
  }

  function renderSlides(){
    var p = state.product;
    slides.innerHTML = '';
    var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);
    imgs.forEach(function(src){
      var slide = document.createElement('div');
      slide.className = 'upsell-modal__slide';
      var img = document.createElement('img');
      img.src = src;
      img.alt = p.title || '';
      img.loading = 'lazy';
      slide.appendChild(img);
      slides.appendChild(slide);
    });
    var multi = slides.children.length > 1;
    prevBtn.hidden = !multi;
    nextBtn.hidden = !multi;
    slideTo(0);
  }

  function slideTo(i){
    var count = slides.children.length;
    if (count === 0) return;
    state.slideIdx = ((i % count) + count) % count;
    slides.style.transform = 'translateX(-' + (state.slideIdx * 100) + '%)';
  }

  function renderAll(){
    var p = state.product;
    titleEl.textContent = p.title || '';
    descEl.innerHTML = p.description || '';
    detailsLink.href = '/products/' + p.handle;
    renderPrices();
    renderAtc();
    renderVariants();
    renderSlides();
  }

  function fetchProduct(handle){
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function(r){ if (!r.ok) throw new Error('Product fetch failed'); return r.json(); })
      .then(function(p){ cache[handle] = p; return p; });
  }

  function open(handle){
    if (!handle) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('upsell-modal-open');
    body.hidden = true;
    loadingEl.hidden = false;
    fetchProduct(handle).then(function(p){
      state.product = p;
      state.variantIdx = 0;
      for (var i = 0; i < p.variants.length; i++){
        if (p.variants[i].available) { state.variantIdx = i; break; }
      }
      loadingEl.hidden = true;
      body.hidden = false;
      renderAll();
    }).catch(function(){
      loadingEl.hidden = true;
      close();
    });
  }

  function close(){
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('upsell-modal-open');
  }

  function addToCart(){
    if (state.busy || !state.product) return;
    var v = state.product.variants[state.variantIdx];
    if (!v.available) return;
    state.busy = true;
    atcBtn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      state.busy = false;
      atcBtn.classList.remove('is-loading');
      close();
      if (typeof window.cart_drawer === 'function') window.cart_drawer();
    })
    .catch(function(){
      state.busy = false;
      atcBtn.classList.remove('is-loading');
    });
  }

  function onDocClick(e){
    var opener = e.target.closest('[data-upsell-handle]');
    if (opener && !opener.classList.contains('item_soldout')) {
      e.preventDefault();
      e.stopPropagation();
      open(opener.getAttribute('data-upsell-handle'));
      return;
    }
    if (!modal || !modal.contains(e.target)) return;

    var chip = e.target.closest('[data-upsell-variant]');
    if (chip) {
      state.variantIdx = parseInt(chip.getAttribute('data-upsell-variant'), 10) || 0;
      renderPrices();
      renderAtc();
      Array.prototype.forEach.call(variantsBox.children, function(el, i){
        el.classList.toggle('is-active', i === state.variantIdx);
      });
      return;
    }
    if (e.target.closest('[data-upsell-close]')) { close(); return; }
    if (e.target.closest('[data-upsell-prev]')) { slideTo(state.slideIdx - 1); return; }
    if (e.target.closest('[data-upsell-next]')) { slideTo(state.slideIdx + 1); return; }
    if (e.target.closest('[data-upsell-atc]')) { addToCart(); return; }
  }

  function onKey(e){
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) close();
  }

  function init(){
    modal = document.getElementById('upsell-modal');
    if (!modal) return;
    body = qs('[data-upsell-body]');
    slides = qs('[data-upsell-slides]');
    viewport = qs('.upsell-modal__slides-viewport');
    variantsWrap = qs('[data-upsell-variants-wrap]');
    variantsBox = qs('[data-upsell-variants]');
    titleEl = qs('[data-upsell-title]');
    descEl = qs('[data-upsell-desc]');
    compareEl = qs('[data-upsell-compare]');
    priceEl = qs('[data-upsell-price]');
    atcBtn = qs('[data-upsell-atc]');
    detailsLink = qs('[data-upsell-details-link]');
    loadingEl = qs('[data-upsell-loading]');
    prevBtn = qs('[data-upsell-prev]');
    nextBtn = qs('[data-upsell-next]');
    document.addEventListener('click', onDocClick, true);
    document.addEventListener('keydown', onKey);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
